import { useState } from "react";
import { StrikerCard } from "../strikerCard";
import { localAlphabets } from "../../constants";
import { Spin } from "antd";

import { SearchAndFineOne } from "../searchAndFind";
import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";

export const Accordians = ({
  users,
  activeTab,
  allStrikersDataLoading,
  userNotInDB,
  search,
}) => {
  const newUserInviteObj = {
    email: search,
  };
  const firstLetters = users?.map(
    (item) => `${item?.username?.trim(" ")?.[0].toLowerCase()}`
  );

  const [activeAlphabet, setAlphabet] = useState("A");
  let letters = [];

  if (firstLetters) {
    letters = Array.from(new Set([...firstLetters])).sort();
  }

  function handleClickLetter(item) {
    setAlphabet(item);
    const element = document.getElementById(`section-${item}`);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.accorrdianContainer}>
        <Spin spinning={allStrikersDataLoading}>
          {letters?.map((item) => (
            <div
              style={{ marginTop: "30px" }}
              id={`section-${item.toUpperCase()}`}
            >
              <h2 style={{ textTransform: "capitalize" }}> {item}</h2>
              <div className={styles.list}>
                {users
                  ?.filter((userItem) =>
                    userItem?.username?.toLowerCase().startsWith(item)
                  )
                  ?.map((filteredItem, index) => (
                    <StrikerCard
                      item={filteredItem}
                      activeTab={activeTab}
                      key={filteredItem?.userId}
                    />
                  ))}
              </div>
            </div>
          ))}
          <ConditionalRenderer condition={userNotInDB && search}>
            <p className={styles.notInDBtext}>
              This user isn’t on Motion2Coach yet — invite them to join the
              platform!
            </p>
            <StrikerCard
              item={newUserInviteObj}
              activeTab={activeTab}
              userNotInDB={userNotInDB}
            />
          </ConditionalRenderer>
          <ConditionalRenderer
            condition={!userNotInDB && search && users?.length < 1}
          >
            <p className={styles.notInDBtext}>No User Found</p>
          </ConditionalRenderer>
        </Spin>
        <ConditionalRenderer
          condition={
            (!users || users?.length < 1) && !search && !allStrikersDataLoading
          }
        >
          <SearchAndFineOne />
        </ConditionalRenderer>
      </div>
      <div className={styles.letters}>
        {localAlphabets?.map((item) => (
          <div
            className={`${styles.singleLetter} ${
              item === activeAlphabet && styles.active
            }`}
            onClick={() => handleClickLetter(item)}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};
